import { motion } from "framer-motion";

export const PageHeader = ({ title, subtitle, actions, testid }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between mb-8"
      data-testid={testid || "page-header"}
    >
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight text-slate-900">
          {title}
        </h1>
        {subtitle && <p className="mt-1 text-sm text-slate-500 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </motion.div>
  );
};

export const Section = ({ title, action, children, className = "" }) => (
  <section className={className}>
    {(title || action) && (
      <div className="flex items-center justify-between mb-4">
        {title && <h2 className="font-heading text-lg font-semibold text-slate-900">{title}</h2>}
        {action}
      </div>
    )}
    {children}
  </section>
);

export const EmptyState = ({ icon: Icon, title, hint, testid }) => (
  <div
    className="flex flex-col items-center justify-center text-center py-16 px-6 rounded-xl border border-dashed border-slate-200 bg-slate-50/50"
    data-testid={testid || "empty-state"}
  >
    {Icon && (
      <div className="h-12 w-12 rounded-xl bg-white border border-slate-200 flex items-center justify-center text-slate-400 mb-4">
        <Icon className="h-5 w-5" />
      </div>
    )}
    <p className="font-medium text-slate-700">{title}</p>
    {hint && <p className="text-sm text-slate-400 mt-1 max-w-sm">{hint}</p>}
  </div>
);
